// import Header from "./Component/Header";
// import "./App.css";
// import "./index.css";
// import { BrowserRouter as Router, Routes, Route, Form } from "react-router-dom";
// import Shop from "./Component/Shop";
// import Contact_us from "./Component/Contact_us";
// import Checkout from "./Component/Checkout";
// import Myaccount from "./Component/Myaccount";
// import Blog from "./Component/Blog";
// import Login from "./Component/Login";
// import Single_products from "./Component/Single_products";
// import Offer from "./Component/Offer";
// import Order from "./Component/Order";
// import Aboutus from "./Component/Aboutus";
// import Shops_category from "./Component/Shops_category";
// import CardList from "./Component/CardList";
// import Favratewishlist from "./Component/Favratewishlist";
// import SearchProducts from "./Component/SearchProducts";
// import Shearch_mobile from "./Component/Shearch_mobile";
// import Track_order from "./Component/Track_order";
// import Moblle_category from "./Component/Moblle_category";
// import Counter from "./Component/Counter";
// import Zooming from "./Component/Zooming";
// import Shubh from "./Component/Shubh";
// import Dommy from "./Component/Dommy";
// import Signin from "./Component/Signin";
// import PrivacyAndPolicy from "./Component/PrivacyAndPolicy";
// import TermsAndCondition from "./Component/TermsAndCondition";
// import TopCashbackStores from "./Component/TopCashbackStores";
// import StoreDetail from "./Component/StoreDetail";
// import Help from "./Component/Help";
// import MissingCashback from "./Component/MissingCashback";
// import TrackedCashback from "./Component/OrderDetails";
// import OrderDetails from "./Component/OrderDetails";
// import FAQ from "./Component/FAQ";
// import ChatWithUs from "./Component/ChatWithUs";
// import GiveFeedback from "./Component/GiveFeedback";
// import ReferEarn from "./Component/ReferEarn";
// import MyReferrals from "./Component/MyReferrals";
// import ReviewsUs from "./Component/ReviewsUs";
// import VisitRetailer from "./Component/VisitRetailer";
// import DealDetail from "./Component/DealDetail";
// import FlashDealsListing from "./Component/FlashDealsListing";
// import PopularBrands from "./Component/PopularBrands";


// function App() {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<Header />}></Route>
//         <Route path="/shop" element={<Shop />}></Route>
//         <Route path="/login" element={<Signin />}></Route>
//         <Route path="/shopscategory" element={<Shops_category />}></Route>
//         <Route path="/shop_grid4" element={<Blog />}></Route>
//         <Route path="/contect_us" element={<Contact_us />}></Route>
//         <Route path="/checkout" element={<Checkout />}></Route>
//         <Route path="/myaccount" element={<Myaccount />}></Route>
//         <Route path="/single_products/:id" element={<Single_products />}></Route>
//         <Route path="/Favratewishlist" element={<Favratewishlist />}></Route>
//         <Route path="/cardlist" element={<CardList />}></Route>
//         <Route path="/offer" element={<Offer />}></Route>
//         <Route path="/order" element={<Order />}></Route>
//         <Route path="/aboutus" element={<Aboutus />}></Route>
//         <Route path="/privacy-policy" element={<PrivacyAndPolicy />}></Route>
//         <Route path="/terms-conditions" element={<TermsAndCondition />}></Route>
//         <Route path="/fruits_vagetables" element={<PopularBrands />}></Route>
//         <Route path="/top-cashback-stores" element={<TopCashbackStores />} />
//         <Route path="/stores/:storeSlug" element={<StoreDetail />} />
//         <Route path="/SearchProducts" element={<SearchProducts />}></Route>
//         <Route path="/Shearch_mobile" element={<Shearch_mobile />}></Route>
//         <Route path="/track_order" element={<Track_order />}></Route>
//         <Route path="/mobile_category" element={<Moblle_category />}></Route>
//         <Route path="/counter" element={<Counter />}></Route>
//         <Route path="/zooming" element={<Zooming />}></Route>
//         <Route path="/shubh" element={<Shubh />}></Route>
//         <Route path="/chk" element={<Dommy />}></Route>
//         <Route path="/help" element={<Help />} />
//         <Route path="/help/missing-cashback" element={<  MissingCashback />} />
//         <Route path="/my-earnings/order-details" element={<OrderDetails />} />
//         <Route path="/help/gethelp" element={<FAQ />} />
//         <Route path="/help/chat-with-us" element={<ChatWithUs />} />
//         <Route path="/help/feedback" element={<GiveFeedback />} />
//         <Route path="/refer-and-earn" element={<ReferEarn />} />
//         <Route path="/my-referrals" element={<MyReferrals />} />
//         {/* <Route path="/reviews-us" element={<ReviewsUs />} /> */}
//         <Route path="/reviews-us" element={<ReviewsUs />} />
//         <Route path="/testimonials" element={<ReviewsUs />} />
//         <Route path="/visit/:type/:id" element={<VisitRetailer />} />
//         <Route path="/deal/:slug" element={<DealDetail />} />
//         <Route path="/flash-deals" element={<FlashDealsListing />} />
//         <Route path="/deals-listing" element={<FlashDealsListing />} />
//       </Routes>
//     </Router>


//   );
// }

// export default App;
import Header from "./Component/Header";
import "./App.css";
import "./index.css";
import { BrowserRouter as Router, Routes, Route, Form } from "react-router-dom";
import MainLayout from "./Component/MainLayout";
import Shop from "./Component/Shop";
import Contact_us from "./Component/Contact_us";
import Checkout from "./Component/Checkout";
import Myaccount from "./Component/Myaccount";
import Blog from "./Component/Blog";
import Login from "./Component/Login";
import Single_products from "./Component/Single_products";
import Offer from "./Component/Offer";
import Order from "./Component/Order";
import Aboutus from "./Component/Aboutus";
import Shops_category from "./Component/Shops_category";
import CardList from "./Component/CardList";
import Favratewishlist from "./Component/Favratewishlist";
import SearchProducts from "./Component/SearchProducts";
import Shearch_mobile from "./Component/Shearch_mobile";
import Track_order from "./Component/Track_order";
import Moblle_category from "./Component/Moblle_category";
import Counter from "./Component/Counter";
import Zooming from "./Component/Zooming";
import Shubh from "./Component/Shubh";
import Dommy from "./Component/Dommy";
import Signin from "./Component/Signin";
import PrivacyAndPolicy from "./Component/PrivacyAndPolicy";
import TermsAndCondition from "./Component/TermsAndCondition";
import TopCashbackStores from "./Component/TopCashbackStores";
import StoreDetail from "./Component/StoreDetail";
import Help from "./Component/Help";
import MissingCashback from "./Component/MissingCashback";
import TrackedCashback from "./Component/OrderDetails";
import OrderDetails from "./Component/OrderDetails";
import FAQ from "./Component/FAQ";
import ChatWithUs from "./Component/ChatWithUs";
import GiveFeedback from "./Component/GiveFeedback";
import ReferEarn from "./Component/ReferEarn";
import MyReferrals from "./Component/MyReferrals";
import ReviewsUs from "./Component/ReviewsUs";
import VisitRetailer from "./Component/VisitRetailer";
import DealDetail from "./Component/DealDetail";
import FlashDealsListing from "./Component/FlashDealsListing";
import PopularBrands from "./Component/PopularBrands";

function App() {
  return (
    <Router>
      <Routes>
        {/* ====== Header wale pages: Shearchbar ek hi baar mount hoga ====== */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Header />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shopscategory" element={<Shops_category />} />
          <Route path="/shop_grid4" element={<Blog />} />
          <Route path="/contect_us" element={<Contact_us />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/myaccount" element={<Myaccount />} />
          <Route path="/single_products/:id" element={<Single_products />} />
          <Route path="/Favratewishlist" element={<Favratewishlist />} />
          <Route path="/cardlist" element={<CardList />} />
          <Route path="/offer" element={<Offer />} />
          <Route path="/order" element={<Order />} />
          <Route path="/aboutus" element={<Aboutus />} />
          <Route path="/privacy-policy" element={<PrivacyAndPolicy />} />
          <Route path="/terms-conditions" element={<TermsAndCondition />} />
          <Route path="/fruits_vagetables" element={<PopularBrands />} />
          <Route path="/top-cashback-stores" element={<TopCashbackStores />} />
          <Route path="/stores/:storeSlug" element={<StoreDetail />} />
          <Route path="/SearchProducts" element={<SearchProducts />} />
          <Route path="/Shearch_mobile" element={<Shearch_mobile />} />
          <Route path="/track_order" element={<Track_order />} />
          <Route path="/mobile_category" element={<Moblle_category />} />
          <Route path="/help" element={<Help />} />
          <Route path="/help/missing-cashback" element={<MissingCashback />} />
          <Route path="/my-earnings/order-details" element={<OrderDetails />} />
          <Route path="/help/gethelp" element={<FAQ />} />
          <Route path="/help/chat-with-us" element={<ChatWithUs />} />
          <Route path="/help/feedback" element={<GiveFeedback />} />
          <Route path="/refer-and-earn" element={<ReferEarn />} />
          <Route path="/my-referrals" element={<MyReferrals />} />
          <Route path="/reviews-us" element={<ReviewsUs />} />
          <Route path="/testimonials" element={<ReviewsUs />} />
          <Route path="/deal/:slug" element={<DealDetail />} />
          <Route path="/flash-deals" element={<FlashDealsListing />} />
          <Route path="/deals-listing" element={<FlashDealsListing />} />
        </Route>

        {/* ====== Bina header wale pages (inme koi badlav nahi) ====== */}
        <Route path="/login" element={<Signin />} />
        <Route path="/visit/:type/:id" element={<VisitRetailer />} />
        <Route path="/counter" element={<Counter />} />
        <Route path="/zooming" element={<Zooming />} />
        <Route path="/shubh" element={<Shubh />} />
        <Route path="/chk" element={<Dommy />} />
      </Routes>
    </Router>
  );
}

export default App;